//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAppggList } from '@/service/service'
import { mapState, mapMutations } from 'vuex'
import config from '../../config/config'

export default {
	data() {
		return {
			currentPage: 1,
			maxpage: '1',
			isNewsInit: false,
			finished: false,
			newsList: [],
			tempItem: [],
		}
	},
	methods: {
		getAppggList() {
			getAppggList({
				TypeCode: '18',
				numPerPage: 30,
				curpage: this.currentPage,
			}).then((resultVo) => {
				let results = resultVo
				this.isNewsInit = true
				if (results.error_no == '0') {
					var datalist = results['DataSet0'] // 加载列表数据
					var dataSet1 = results['DataSet1']
					this.maxpage = dataSet1[0].totalPages
					if (dataSet1 != null && dataSet1.length > 0) {
						if (this.currentPage == '1') {
							this.tempItem = datalist[0]
							this.newsList = []
						}

						if (this.currentPage == 1) {
							this.newsList = datalist
						} else if (this.currentPage > 1) {
							this.newsList = this.newsList.concat(datalist)
						}

						this.$nextTick(function () {
							console.log(this.$refs.iframe.contentWindow.document.body)
							var _this = this
							var scrollmain = this.$refs.main
							scrollmain.addEventListener('scroll', function () {
								var scrollTop = this.scrollTop
								var finished = true
								if (finished && this.scrollHeight - this.clientHeight == this.scrollTop) {
									finished = false
									_this.changePage()
									_this.getAppggList()
								}
							})
						})
					}
				}
			})
		},
		changePage() {
			if (this.currentPage <= this.currentPage) {
				this.currentPage = parseInt(this.currentPage) + 1
			}
		},
		toDetail(item) {
			this.tempItem = item
		},
		topage(item) {
			if (item.path) {
				let path = item.path
				let name = ''
				if (item.path == '/') {
					name = '主页'
				} else if (item.path == '/product') {
					name = '产品列表'
				} else if (item.path == '/news') {
					name = '理财资讯'
				}
				if (window.qt) {
					try {
						window.QtSubmit.JSICallMethod('ehtsec://nativeLog?event=tabView&openType=理财&tab=' + name)
					} catch (e) {
						console.log(e)
					}
				}
				this.$router.push(path)
			}
		},
	},
	created() {
		this.getAppggList()
	},
}



// WEBPACK FOOTER //
// ./src/pages/news.vue